import styles from './documentsPage.module.scss'

export default function DocumentStatusPill({ status }) {
  if (status === 'failed') {
    return <span className={`${styles.statusPill} ${styles.statusPillFailed}`}>Failed</span>
  }
  if (status === 'uploaded' || status === 'processing') {
    return <span className={styles.statusPill}>Processing</span>
  }
  return null
}
